<template>
    <ValidationProvider
        :name="name"
        :rules="rules"
        :class="classWrapper"
        tag="div"
    >
        <div class="color-container" @click="triggerInput">
            <div
                class="color-container__circle"
                :style="{ backgroundColor: value }"
            ></div>
            <div class="color-container__text text-secondary">{{ value }}</div>
            <input
                @input="onInput"
                :value="value"
                :id="name"
                type="color"
                ref="inputColor"
            />
        </div>
    </ValidationProvider>
</template>

<script>
export default {
    name: 'ColorField',
    props: {
        label: String,
        value: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        rules: {
            type: [String, Array, Object],
        },
        classWrapper: {
            type: String,
        },
    },
    methods: {
        onInput(event) {
            this.$emit('input', event.target.value);
        },
        triggerInput() {
            this.$refs.inputColor.click();
        },
    },
};
</script>

<style lang="scss" scoped>
.color-container {
    width: 120px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #666;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;

    &__circle {
        min-width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #666;
    }

    input {
        opacity: 0;
    }
}
</style>
